$(document).ready(function() {
  $('#new_privacy_policy').submit(function(event) {
    if (!!!$('#new_privacy_policy #privacy_policy_application_id').val()) {
      if (!confirm('Heads up! You have not selected any Organisations. This mean that the uploaded privacy policy will replace the existing Appical privacy policy. Are you sure you would like to proceed?')) {
        return false;
      }
    }
    return true;
  });
});